<div class="checklist-page">
	<div class="checklist-page__header">
		<h2 class="checklist-page__title">Request</h2>
		@if (items.length > 0) {
			<span class="checklist-page__badge">{{ items.length }}</span>
		}
		<app-cbta-daterange-filter
			[startDate]="startDate"
			[endDate]="endDate"
			(dateRangeSelected)="handleDateRangeChange($event)"
		></app-cbta-daterange-filter>
	</div>

	<div class="cbta-tbl checklist-tbl">
		<div class="columns">
			<div class="column col-12">
				<ngx-table
					[configuration]="configuration"
					[data]="items"
					[pagination]="pagination"
					[noResultsTemplate]="noResultsTemplate"
					[columns]="columns"
				>
				</ngx-table>
			</div>

			<ng-template #requestIdTpl let-row>
				<span class="checklist-page__request-id">{{ formatRowRequestId(row) }}</span>
			</ng-template>

			<ng-template #requestTypeTpl let-row>
				<span>{{ requestTypeLabel(row) }}</span>
			</ng-template>

			<ng-template #instructorTpl let-row>
				<span>{{ fromLabel(row) }}</span>
			</ng-template>

			<ng-template #dateTpl let-row>
				<span class="checklist-page__date">{{ formatSubmittedAt(row.submittedAt) }}</span>
			</ng-template>

			<ng-template #actionTpl let-row>
				<button type="button" class="aa-btn" data-size="small" data-variant="primary" (click)="openItem(row)">
					Continue
				</button>
			</ng-template>

			<ng-template #noResultsTemplate>
				@if (columns) {
					<td [attr.colspan]="columns.length" class="h-[180px] text-center">
						<span class="text-grey-40">No pending requests.</span>
					</td>
				}
			</ng-template>
		</div>
	</div>
</div>
